//import Libraries
//import Components
//import Style classes
import React from 'react';

import './ScrollImage.css'

const scrollimage = (props) => {
    let layerImages = [];
    let layerMainNumber;
    if(typeof props.layerNumber !== 'string'){
        layerMainNumber = props.layerNumber[0]
        layerImages = props.layerNumber.map((obj, idx)=>{
                return <React.Fragment key={idx}>
                        <img 
                            id={"layer-"+obj} 
                            src={require("../../../../assets/scroll/layer-"+obj+".png")} 
                            alt=""/>
                        <div id={"layer-"+obj+"s"} className="LayerSelector">
                            {/* <svg version="1.1" x="0px" y="0px" width="69px" height="69px" viewBox="0 0 69 69" enable-background="new 0 0 69 69">
                                <path d="M34.5,0C15.446,0,0,15.446,0,34.5S15.446,69,34.5,69S69,53.554,69,34.5S53.554,0,34.5,0z M53.75,36.281H36.281V53.75h-3.563
                                    V36.281H15.25v-3.563h17.469V15.25h3.563v17.469H53.75V36.281z"/>
                            </svg> */}
                        </div>
                        </React.Fragment>
            })
    } else {
        layerMainNumber = props.layerNumber;
        layerImages = (
            <React.Fragment>
                <img 
                    id={"layer-"+props.layerNumber} 
                    src={require("../../../../assets/scroll/layer-"+props.layerNumber+".png")} 
                    alt=""/> 
                <div id={"layer-"+props.layerNumber+"s"} className="LayerSelector">
                    {/* <svg version="1.1" x="0px" y="0px" width="69px" height="69px" viewBox="0 0 69 69" enable-background="new 0 0 69 69">
                        <path d="M34.5,0C15.446,0,0,15.446,0,34.5S15.446,69,34.5,69S69,53.554,69,34.5S53.554,0,34.5,0z M53.75,36.281H36.281V53.75h-3.563
                            V36.281H15.25v-3.563h17.469V15.25h3.563v17.469H53.75V36.281z"/>
                    </svg> */}
                </div>
            </React.Fragment>
        )
    }
    return (
        <div id={"layer-div-"+layerMainNumber} className="ScrollImage">
            {layerImages}
        </div>
    );
}

export default scrollimage;


// WEBPACK FOOTER //
// ./src/pages/Home/ScrollSection/ScrollImage/ScrollImage.js